/** All UI text in one place (Serbian first; an English table can be added next to it). */
export const t = {
  title: "Jedna!",
  tagline: "Karte za stolom, uživo.",
  allGames: "Sve igre",
  chooseGame: "Izaberi igru za večeras",
  opponents: "Protivnici",
  botLevel: "Botovi",
  easy: "Lako",
  normal: "Normalno",
  houseRules: "Kućna pravila",
  stacking: "Slaganje +2 / +4",
  drawUntil: "Vuci dok ne možeš da odigraš",
  yourName: "Tvoje ime",
  defaultName: "Ti",
  cameraTest: "Test kamere (tvoja kamera na svim mestima)",
  play: "Igraj",
  holdHint: "Drži telefon položeno, obema rukama, kao lepezu karata.",
  rotate: "Okreni telefon položeno",
  yourTurn: "TVOJ POTEZ",
  turnOf: (name: string) => `NA POTEZU: ${name.toUpperCase()}`,
  chooseColor: "DŽOKER · IZABERI BOJU",
  chooseColorHint: "Dodirni boju",
  keep: "Zadrži kartu",
  afterDrawHint: "Možeš odmah da baciš izvučenu kartu",
  challenge: "Izazovi",
  accept: "Prihvati +4",
  challengeHint: (name: string) => `${name}: +4. Da li je blef?`,
  jedna: "JEDNA!",
  catch: "Uhvati!",
  skipped: "Preskače",
  youSkipped: "Preskočen si!",
  reversed: "Obrnut smer",
  saidJedna: "Jedna!",
  caught: "Uhvaćen! +2",
  youCaught: "Uhvaćen si! +2",
  bluffed: "Blef! +4 nazad",
  honest: "Pošteno! +6 izazivaču",
  notYourTurn: "Nije tvoj red",
  illegal: "Ta karta ne ide na ovu",
  mustPlayDrawn: "Samo izvučenu kartu ili „Zadrži“",
  draws: (n: number) => `+${n}`,
  roundWin: "Pobeda!",
  roundLose: (name: string) => `Pobednik: ${name}`,
  total: "Ukupno",
  thisRound: "Runda",
  matchWinner: (name: string) => `Kraj igre! Pobednik: ${name}`,
  newMatch: "Nova igra",
  scoringSerbianHint: (target: number) =>
    `Pobednik runde −10 (−20 ako izađe crnom kartom), ostali pišu svoje karte. Kad neko stigne do ${target}, pobeđuje ko ima najmanje.`,
  scoringOfficialHint: (target: number) => `Pobednik runde dobija poene iz tuđih ruku. Prvi do ${target} pobeđuje.`,
  standingsTitle: "Rezultat",
  roundsPlayed: (n: number) => (n === 1 ? "1 runda" : n >= 2 && n <= 4 ? `${n} runde` : `${n} rundi`),
  playTo: (n: number) => `igra se do ${n}`,
  playToLabel: "Igra se do",
  showRounds: (n: number) => `Prethodne runde (${n})`,
  hideRounds: "Sakrij runde",
  round: "Runda",
  nextDeal: (dealer: string, first: string) => `Sledeću deli ${dealer}, prvi igra ${first}.`,
  deals: "Deli",
  playsFirst: "Prvi igra",
  serbianScoring: "Srpsko bodovanje (pobednik −10)",
  nextRound: "Nova partija",
  menu: "Meni",
  settings: "Podešavanja",
  recenter: "Centriraj",
  gyro: "Pomeranje telefonom",
  vibration: "Vibracija",
  sound: "Zvuk",
  fps: "Prikaži FPS",
  reset: "Vrati podrazumevano",
  close: "Zatvori",
  gyroMissing: "Žiroskop nije dostupan: prevlači prstom gore-dole po stolu.",
  botNames: ["Ana", "Marko", "Jelena", "Nikola", "Tijana"],
  // --- online ---
  soloTitle: "Igraj protiv botova",
  onlineTitle: "Igraj sa prijateljima",
  createTable: "Napravi sto i pozovi",
  joinTitle: "Poziv za sto",
  joinAs: "Uđi za sto",
  camera: "Kamera",
  lookTitle: "Izgled stola i prostora",
  tableLabel: "Sto",
  roomLabel: "Prostor",
  controlsTitle: "Upravljanje i zvuk",
  inAppTitle: "Otvoreno je u pregledaču Messengera / druge aplikacije.",
  inAppText:
    "Igra je mnogo glatkija u Chrome-u (3D, ceo ekran, kamera i žiroskop). Jedan dodir i nastavljaš za istim stolom.",
  openInChrome: "Otvori u Chrome-u",
  copyLink: "Kopiraj link",
  stayHere: "Nastavi ovde",
  tapForFullscreen: "Dodirni ⛶ za ceo ekran",
  fullscreen: "Ceo ekran",
  allowMediaNow: "Dozvoli kameru i mikrofon sada, da igra posle ostane preko celog ekrana.",
  microphone: "Mikrofon",
  acceptTerms: "Prihvatam uslove igre",
  readTerms: "Pročitaj uslove",
  termsRequired: "Prvo prihvati uslove igre.",
  tableCode: (code: string) => `Sto ${code}`,
  invite: "Pozovi prijatelje",
  copied: "Link je kopiran",
  inviteText: "Hajde na partiju Jedna! za mojim stolom:",
  addBot: "+ Bot",
  removeBot: "− Bot",
  startGame: "Počni igru",
  waitingHost: "Čeka se da domaćin počne…",
  waitingDeal: "Čeka se da domaćin podeli…",
  needTwo: "Potrebna su bar 2 igrača (dodaj bota).",
  host: "domaćin",
  away: "(nema veze)",
  offline: "Nema veze sa serverom, pokušavam ponovo…",
  errors: {
    no_room: "Taj sto više ne postoji.",
    full: "Sto je pun (najviše 6).",
    started: "Igra za tim stolom je već počela.",
    rate_limited: "Previše pokušaja, sačekaj malo.",
    bad_request: "Nešto nije u redu sa zahtevom.",
    not_host: "Samo domaćin to može.",
    offline: "Nema veze sa serverom.",
  } as Record<string, string>,
  termsTitle: "Uslovi igre",
  terms: [
    "Za stolom je privatna, nekomercijalna zbirka igara za društvo prijatelja. Učešće je dobrovoljno i besplatno.",
    "Kamera i mikrofon su opcioni. Slika i zvuk idu direktno između telefona igrača za istim stolom; ne snimaju se i ne čuvaju se nigde, ni na serveru.",
    "Svaki igrač je sam odgovoran za ono što pokazuje i govori. Zabranjen je uvredljiv, nasilan, seksualni ili drugi neprimeren sadržaj. Ne snimaj i ne deli sliku ili zvuk drugih bez njihovog pristanka.",
    "Ako ti se nešto ne dopada, isključi kameru ili mikrofon i napusti sto. Domaćin sam bira koga poziva.",
    "Ime koje uneseš važi samo za tu igru. Ne pravimo naloge i ne čuvamo lične podatke.",
    "Igra se pruža „takva kakva jeste“, bez ikakvih garancija. Organizator i autor ne odgovaraju za ponašanje učesnika niti za bilo kakvu štetu nastalu korišćenjem.",
    "Igra je namenjena odraslima; mlađi od 18 godina igraju samo uz dozvolu roditelja.",
    "Ulaskom za sto potvrđuješ da si pročitao/la i prihvataš ove uslove.",
  ],
  remi: {
    title: "Remi 51",
    tagline: "Složi. Otvori se. Zatvori.",
    rulesTitle: "Pravila ove verzije",
    rulesSummary:
      "2 špila + 4 džokera · 14 karata (prvi 15) · otvaranje 51 · niz iste boje ili isti broj različitih znakova.",
    rulesDetails: [
      "Prvi krug je bez otvaranja. U svakom potezu kupi jednu kartu, složi kombinacije i odbaci jednu.",
      "Niz ima najmanje 3 uzastopne karte istog znaka. As može biti pre dvojke ili posle kralja, ali nema K–A–2.",
      "Komplet ima 3 ili 4 iste vrednosti, bez ponovljenog znaka. Pri prvom otvaranju grupa ima najviše jednog džokera.",
      "Za otvaranje sopstvene nove kombinacije moraju vredeti najmanje 51. Posle toga možeš dodavati na sto i menjati džokera.",
      "Poslednja karta mora da se odbaci. Pobeda je −40, hand −80; neotvoren igrač dobija +100, džoker u ruci +20.",
    ],
    arrange: "Rasporedi",
    arrangeDone: "Gotovo",
    moveLeft: "← Levo",
    moveRight: "Desno →",
    arrangeHelp: "Prevuci kartu ili je izaberi pa pomeri levo/desno. Redosled biraš ti.",
    optionalOpening: "Otvaranje nije obavezno. Kupi kartu, pa izaberi jednu za odbacivanje.",
    discardOnly: "Baci bez otvaranja",
    draw: "Kupi kartu",
    drawOpen: "Uzmi bačenu",
    makeGroup: "Dodaj grupu",
    addToMeld: "Dodaj na izabranu grupu",
    discard: "Baci i završi potez",
    clearDraft: "Vrati potez",
    selected: (n: number) => `Izabrano: ${n}`,
    draftGroups: (n: number) => `Grupe u potezu: ${n}`,
    openingPrepared: "Otvaranje je pripremljeno. Izaberi kartu za odbacivanje i potvrdi potez.",
    discardLocked: "Bačena karta je dostupna tek uz otvaranje od 51. Kupi sa špila.",
    recoveredJoker: "Vraćeni džoker čeka: izaberi najmanje dve karte i dodaj novu grupu.",
    exactJoker: "Izaberi tačno broj i znak koje džoker zamenjuje.",
    publicOwner: (name: string) => `Otvorio/la: ${name}`,
    needDraw: "Kupi kartu sa špila ili uzmi poslednju bačenu.",
    selectCards: "Izaberi najmanje 3 karte za novu grupu ili jednu za odbacivanje.",
    yourTurn: "TVOJ POTEZ · REMI 51",
    firstLap: "Prvi krug: samo odbaci kartu.",
    sortSuit: "♠ Po znaku",
    sortRank: "777 Po broju",
    reorderHint: "Prevuci kartu na željeno mesto u ruci.",
    selectForTable: "Prvo izaberi kartu iz ruke, pa grupu na stolu.",
    invalidAddition: "Izabrane karte ne odgovaraju toj grupi.",
    keepDiscard: "Sačuvaj jednu kartu za odbacivanje.",
    openingNeeded: (n: number) => `Prvo složi svoje grupe za otvaranje: najmanje ${n} poena.`,
    openingProgress: (n: number, target: number) => `Nove grupe: ${n}/${target} poena`,
    draftAdditions: (n: number) => `Dodavanja: ${n}`,
    invalidGroup: "Te karte ne čine ispravnu grupu.",
    openingLow: "Za prvo otvaranje treba najmanje 51.",
    hand: "HAND!",
    inviteText: "Hajde na Remi 51 za mojim stolom:",
    publicTable: "Karte na stolu",
    publicTableHelp:
      "Izaberi karte iz ruke, pa dodirni grupu za dodavanje ili džokera za zamenu. Zlatna ivica označava dostupnu radnju.",
    publicDiscard: "Poslednja bačena",
    publicNoDiscard: "Još nema bačenih karata.",
    publicRun: "Niz",
    publicSet: "Komplet",
    publicDraft: "U pripremi",
    publicReplace: "Zameni džokera",
    publicJoker: "Džoker",
    publicEmpty: "Otvorene kombinacije će se pojaviti ovde.",
    scoringHint: (target: number) =>
      `Pobednik −40, hand −80; neotvoren +100. Kada neko stigne do ${target}, pobeđuje najmanji zbir.`,
  },
};
